import { useConfirmDialog } from '@vueuse/core';

const dialog = useConfirmDialog();

const useGlobalDialog = () => dialog;

export default useGlobalDialog;
